import React, { Component } from 'react';
import { connect } from 'react-redux';
import DetailedView from './DetailedView';
import Price from '../../../utils/Price';

class Product extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDetailedView: false,
    };
    this.toggleView = this.toggleView.bind(this);
  }

  toggleView() {
    this.setState(prevState => ({ showDetailedView: !prevState.showDetailedView }));
  }

  render() {
    let costumizationPrice = 0;
    this.props.sizes.map(size => (
      size.customizations.map((customization) => {
        if (customization.length > 0) {
          customization.map((item) => {
            costumizationPrice += item.price;
            return costumizationPrice;
            });
        }
        return null;
      })
    ));

    const types = {
      tshirt: 'Shirt',
      shorts: 'Shorts',
      others: 'Sock',
    };

    const { currency } = this.props;

    return (
      <div className="previewProduct">
        <div className="accentuatedProductInfo">
          <div className="imageContainer">
            <img src={this.props.image} alt="product img" />
          </div>
          <div className="totalQuantity">
            {this.props.totalQuantity}
            {' '}
            {this.props.reviewTranslations.pcs}
          </div>
          <div className="productName">
            {this.props.name}
          </div>
          <div className="productPrice">
            <Price
              isTotal
              isTeamSport
              priceNet={this.props.unitNetPrice}
              currency={currency}
            />
            {' '}
            {this.props.reviewTranslations.pcsWithChars}
          </div>
          <div className="totalProductPrice">
            <Price
              isTotal
              isTeamSport
              priceNet={this.props.unitNetPrice * this.props.totalQuantity}
              currency={currency}
            />
          </div>
        </div>

        <div className="underemphasizedProductInfo">
          <div className="itemLine">
            <div className="itemizedName">{this.props.generalTranslations[types[this.props.type]]}</div>
            <div className={this.props.unitPrice === this.props.unitNetPrice ? 'itemizedPrice productPrice' : 'itemizedPrice productPrice netPrice'}>
              <Price
                isTotal
                isTeamSport
                priceNet={this.props.unitPrice}
                currency={currency}
              />
              {' '}
              {this.props.reviewTranslations.pcsWithChars}
            </div>
            <div className={this.props.unitPrice === this.props.unitNetPrice ? 'itemizedPrice' : 'itemizedPrice netPrice'}>
              <Price
                isTotal
                isTeamSport
                priceNet={this.props.unitPrice * this.props.totalQuantity}
                currency={currency}
              />
            </div>
          </div>
          <div className="itemLine">
            <div className="itemizedName">{this.props.reviewTranslations.Discount}</div>
            <div className="itemizedPrice productPrice discountPrice">
              {'- '}
              <Price
                isTotal
                isTeamSport
                priceNet={this.props.unitDiscount}
                currency={currency}
              />
              {' '}
              {this.props.reviewTranslations.pcsWithChars}
            </div>
            <div className="itemizedPrice">
              {'- '}
              <Price
                isTotal
                isTeamSport
                priceNet={this.props.unitDiscount * this.props.totalQuantity}
                currency={currency}
              />
            </div>
          </div>
          <div className="itemLine">
            <div className="itemizedName">{this.props.reviewTranslations.Print}</div>
            <div className="itemizedPrice pullRight">
              <Price
                isTotal
                isTeamSport
                priceNet={costumizationPrice}
                currency={currency}
              />
            </div>
          </div>
          {this.state.showDetailedView ?
            <DetailedView
              id={this.props.id}
              name={this.props.name}
              image={this.props.image}
              currency={this.props.currency}
              productType={this.props.type}
              customizations={this.props.sizes}
              price={this.props.unitNetPrice}
              unitCustomizationExcludingVat={this.props.unitCustomizationExcludingVat}
              unitCustomizationPrice={this.props.unitCustomizationPrice}
              unitCustomizationVat={this.props.unitCustomizationVat}
              unitDiscount={this.props.unitDiscount}
              unitNetPrice={this.props.unitNetPrice}
              unitPrice={this.props.unitPrice}
              totalQuantity={this.props.totalQuantity}
            />
          :
            null
          }
          <div
            className={this.state.showDetailedView ? 'detailedView expanded' : 'detailedView'}
            onClick={() => this.toggleView()}
            role="button"
            tabIndex="0"
            style={{ outline: 'none' }}
          >
            {this.props.reviewTranslations.DetailedView}
            <span className="arrow" />
          </div>
        </div>
      </div>
    );
  }
}
const mapState = state => (
  {
    total: state.total,
    settings: state.settings,
    generalTranslations: state.generalTranslations,
    reviewTranslations: state.reviewTranslations,
  }
);

export default connect(mapState, null)(Product);
